export default "__VITE_ASSET__BEEtqLxy__"